import React from "react";
import {
  ManagerProfileEditingSection,
  useManagerProfile,
} from "../ManagerProfileProvider";
import { ManagerProfileSection } from "../ManagerProfileSection";
import { ManagerProfileEmptySection } from "../ManagerProfileEmptySection";
import { Grid } from "@chakra-ui/react";
import { formatDateMMDDYYYY } from "../../../utils/dates";
import { ManagerOverviewInfo } from "../ManagerOverviewInfo";
import { numberFormatter } from "../../../utils";
import { ManagerProfileDivider } from "../ManagerProfileDivider";

const criterias = [
  {
    name: "Investment Programs Offered",
    type: "investment_program",
  },
  {
    name: "Property Types",
    type: "property_type",
  },
  {
    name: "Regions",
    type: "region",
  },
  {
    name: "Strategies Employed",
    type: "strategy",
  },
  {
    name: "Investment Type",
    type: "investment_type",
  },
  {
    name: "Risk Profile",
    type: "risk_profile",
  },
  {
    name: "Primary Markets",
    type: "market",
  },
];

export const Details: React.FC = () => {
  const { manager, isEditing, setEditingDrawer } = useManagerProfile();

  const hasDetails =
    !!manager?.capitalManaged ||
    !!manager?.yearsPrincipalExperience ||
    !!manager?.yearsRealEstateExperience ||
    (manager?.attributeitems?.length || 0) > 0;

  if (!isEditing && !hasDetails) return <></>;

  return (
    <>
      <ManagerProfileDivider />
      <ManagerProfileSection
        w={"100%"}
        title={"Details"}
        action={() => setEditingDrawer(ManagerProfileEditingSection.Details)}
      >
        {isEditing && !hasDetails && (
          <ManagerProfileEmptySection
            description={
              "What are the notable attributes of your firm? This information can help set you apart from other investment managers."
            }
            buttonLabel={"Add details"}
            onAction={() =>
              setEditingDrawer(ManagerProfileEditingSection.Details)
            }
          />
        )}

        {hasDetails && (
          <Grid templateColumns={{ base: "1fr", md: "1fr 1fr 1fr" }} gap={8}>
            {!!manager.capitalManaged && (
              <ManagerOverviewInfo
                title="investor capital managed"
                text={numberFormatter.format(manager.capitalManaged || 0)}
                subText={
                  manager.lastUpdatedCapitalManaged &&
                  `Last updated ${formatDateMMDDYYYY(
                    manager.lastUpdatedCapitalManaged,
                  )}`
                }
              />
            )}
            {!!manager.yearsPrincipalExperience && (
              <ManagerOverviewInfo
                title="Principal Experience"
                text={manager.yearsPrincipalExperience + " Years"}
              />
            )}
            {!!manager.yearsRealEstateExperience && (
              <ManagerOverviewInfo
                title="Real Estate Experience"
                text={manager.yearsRealEstateExperience + " Years"}
              />
            )}
            {criterias.map((c, i) => {
              const data = manager.attributeitems?.filter(
                (a) => a.attributeType === c.type,
              );
              if (data && data.length > 0) {
                return (
                  <ManagerOverviewInfo
                    key={"managersOverviewInfo" + i}
                    title={c.name}
                    text={data.map((d) => d.name).join(", ")}
                  />
                );
              }
              return null;
            })}
          </Grid>
        )}
      </ManagerProfileSection>
    </>
  );
};
